import createInvoiceFieldMutation from './createInvoiceFieldMutation'

const useFinalizeInvoice = createInvoiceFieldMutation({ finalized: true }, 'finalizeInvoice')

export default useFinalizeInvoice
